export default __webpack_public_path__ + "static/media/virtual_tour_cover.c9bcc460.png";